"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Lang_js_1 = require("../Lang.js");
var apiResponse_1 = require("../apiResponse");
var LANGUAGE_NAMES = {
    en: 'English',
    es: 'Español',
    pt: 'Português',
};
/**
 * "Report a renewal form problem" — a minister describes what went wrong and it goes
 * straight to the board-monitored help address, with their identifying details attached
 * server-side so whoever reads it can look the renewal up without a further exchange.
 *
 * Browser and device are prefilled from the browser itself: a minister reporting a
 * problem often cannot answer "what browser are you using?", and the raw user agent is
 * sent regardless, so the answer arrives even when the fields are left alone.
 */
var ProblemReportDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, renewalId = _a.renewalId, blankForms = _a.blankForms;
    var _b = (0, react_1.useState)(''), problem = _b[0], setProblem = _b[1];
    var _c = (0, react_1.useState)(''), email = _c[0], setEmail = _c[1];
    var _d = (0, react_1.useState)(''), phone = _d[0], setPhone = _d[1];
    var _e = (0, react_1.useState)(function () { return guessBrowser(); }), browser = _e[0], setBrowser = _e[1];
    var _f = (0, react_1.useState)(function () { return guessDevice(); }), device = _f[0], setDevice = _f[1];
    var _g = (0, react_1.useState)(false), sending = _g[0], setSending = _g[1];
    var _h = (0, react_1.useState)(false), sent = _h[0], setSent = _h[1];
    var _j = (0, react_1.useState)(''), error = _j[0], setError = _j[1];
    var forms = Object.entries(blankForms || {});
    var reset = function () {
        setProblem('');
        setEmail('');
        setPhone('');
        setSending(false);
        setSent(false);
        setError('');
    };
    var close = function () {
        reset();
        onClose();
    };
    var submit = function () {
        setError('');
        if (!problem.trim() || !email.trim()) {
            setError((0, Lang_js_1.__)('Please describe the problem and give us your email address.'));
            return;
        }
        setSending(true);
        axios_1.default
            .post('/api/ministry/renewal/report', {
            problem: problem,
            email: email,
            phone: phone,
            browser: browser,
            device: device,
            renewal_id: renewalId,
        })
            .then(function (response) {
            setSending(false);
            // The global axios validateStatus override delivers 4xx here with a
            // non-JSON body, so a failure must be recognised rather than assumed.
            if (!(0, apiResponse_1.isJsonSuccess)(response)) {
                setError((0, Lang_js_1.__)('We could not send your report just now. Please try again in a moment.'));
                return;
            }
            setSent(true);
        })
            .catch(function () {
            setSending(false);
            setError((0, Lang_js_1.__)('We could not send your report just now. Please try again in a moment.'));
        });
    };
    return (react_1.default.createElement(Dialog_1.default, { open: open, onClose: close, maxWidth: "sm", fullWidth: true },
        react_1.default.createElement(DialogTitle_1.default, null, (0, Lang_js_1.__)('Report a renewal form problem')),
        react_1.default.createElement(DialogContent_1.default, { id: "renewal-problem-dialog" }, sent ? (react_1.default.createElement(Alert_1.default, { severity: "success", sx: { mt: '8px' } }, (0, Lang_js_1.__)('Thank you — we will respond as soon as possible.'))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555', mb: '16px' } }, (0, Lang_js_1.__)('Tell us what went wrong and someone from the Ministerial Board will get back to you.')),
            error && react_1.default.createElement(Alert_1.default, { severity: "error", sx: { mb: '14px' } }, error),
            react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Problem'), value: problem, onChange: function (e) { return setProblem(e.target.value); }, required: true, multiline: true, minRows: 3, fullWidth: true, margin: "normal", size: "small" }),
            react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Your email'), value: email, onChange: function (e) { return setEmail(e.target.value); }, required: true, type: "email", fullWidth: true, margin: "normal", size: "small" }),
            react_1.default.createElement(Typography_1.default, { sx: {
                    fontSize: '12px',
                    fontWeight: 600,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: '#8a8a8a',
                    mt: '22px',
                    mb: '10px',
                    pt: '16px',
                    borderTop: '1px solid #eee',
                } }, (0, Lang_js_1.__)('Optional — these help us work out what went wrong')),
            react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Your phone'), value: phone, onChange: function (e) { return setPhone(e.target.value); }, fullWidth: true, margin: "normal", size: "small" }),
            react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('What browser are you using?'), value: browser, onChange: function (e) { return setBrowser(e.target.value); }, fullWidth: true, margin: "normal", size: "small" }),
            react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('What device or computer are you using?'), value: device, onChange: function (e) { return setDevice(e.target.value); }, fullWidth: true, margin: "normal", size: "small" }),
            forms.length > 0 && (react_1.default.createElement(Box_1.default, { sx: { mt: '18px', pt: '14px', borderTop: '1px solid #eee' } },
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', mb: '6px' } }, (0, Lang_js_1.__)('If you would rather complete a paper form, download a blank renewal:')),
                forms.map(function (_a) {
                    var code = _a[0], url = _a[1];
                    return (react_1.default.createElement(Link_1.default, { key: code, href: url, target: "_blank", rel: "noopener noreferrer", sx: { fontSize: '13px', mr: '14px' } }, LANGUAGE_NAMES[code] || code));
                })))))),
        react_1.default.createElement(DialogActions_1.default, null, sent ? (react_1.default.createElement(Button_1.default, { onClick: close, variant: "contained" }, (0, Lang_js_1.__)('Close'))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.default, { onClick: close, disabled: sending }, (0, Lang_js_1.__)('Cancel')),
            react_1.default.createElement(Button_1.default, { onClick: submit, variant: "contained", disabled: sending }, sending ? (0, Lang_js_1.__)('Sending…') : (0, Lang_js_1.__)('Submit')))))));
};
/** Readable browser name from the user agent — a starting point the minister can correct. */
function guessBrowser() {
    var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    if (/Edg\//.test(ua))
        return 'Microsoft Edge';
    if (/OPR\//.test(ua))
        return 'Opera';
    if (/Chrome\//.test(ua) && !/Chromium/.test(ua))
        return 'Chrome';
    if (/Firefox\//.test(ua))
        return 'Firefox';
    if (/Safari\//.test(ua) && !/Chrome/.test(ua))
        return 'Safari';
    return '';
}
/** Rough device/platform, same purpose as guessBrowser(). */
function guessDevice() {
    var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    if (/iPhone/.test(ua))
        return 'iPhone';
    if (/iPad/.test(ua))
        return 'iPad';
    if (/Android/.test(ua))
        return 'Android';
    if (/Macintosh/.test(ua))
        return 'Mac';
    if (/Windows/.test(ua))
        return 'Windows PC';
    return '';
}
exports.default = ProblemReportDialog;
